/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateSequenceMutationRequest,
  UpdateSequenceMutationResponse,
  UpdateSequencePathParams,
  UpdateSequence400,
  UpdateSequence404,
} from '../types/UpdateSequence'

function getUpdateSequenceUrl({ id }: { id: UpdateSequencePathParams['id'] }) {
  const res = {
    method: 'PUT',
    url: `/api/v1/emailbison/sequences/${id}/` as const,
  }
  return res
}

/**
 * @description Update an existing sequence.
 * Request body:
 * title: string (optional) - New sequence title
 * steps: array (optional) - New list of step objects (replaces all)
 * @summary Update a sequence
 * {@link /api/v1/emailbison/sequences/:id/}
 */
export async function updateSequence(
  { id }: { id: UpdateSequencePathParams['id'] },
  data?: UpdateSequenceMutationRequest,
  config: Partial<RequestConfig<UpdateSequenceMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateSequenceMutationResponse,
    ResponseErrorConfig<UpdateSequence400 | UpdateSequence404>,
    UpdateSequenceMutationRequest
  >({
    method: 'PUT',
    url: getUpdateSequenceUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
